import React, { useEffect, useState } from "react";
import axios from "axios";

import PersonalReceptTable from "./components/PersonalReceptTable";
import Navbar from "./components/Navbar";
import { goLogin, getPermission, getStampTime } from "./js/main";
import Conf from "./Conf";
import Grid from "@material-ui/core/Grid";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import TextField from "@material-ui/core/TextField";
import ReplayIcon from "@material-ui/icons/Replay";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import PageHead from "./components/PageHead";
import PrintIcon from "@material-ui/icons/Print";

const current_path = Conf.frontendURL + "receive";
const page_title = "หลักฐานการส่งเงิน";
const cookie = JSON.parse(localStorage.getItem(Conf.cookieName));
export default function Delivery(props) {
  const [profile, setProfile] = useState(null);
  const [bills, setBills] = useState({ result: [] });
  const [subTitle, setSubTitle] = useState("");

  useEffect(() => {
    async function getAuth() {
      if (cookie && cookie.token) {
        var auth = await getPermission(cookie.token);
        if (auth === false) goLogin(current_path);
        else {
          setProfile(auth.profile);
        }
      } else goLogin(current_path);
    }
    if (!profile) getAuth();
  }, [profile]);

  async function changeFilter(form) {
    let Query = {
      $and: [
        {
          transactionDateandTime: { $gte: form.fromDate + "T" + form.fromTime },
        },
        {
          transactionDateandTime: { $lte: form.toDate + "T" + form.toTime },
        },
        {
          "operator.usn": profile.usn,
        },
      ],
    };
    let SubTitle =
      "ตั้งแต่ " +
      form.fromDate +
      " เวลา " +
      document.getElementById("fromTime").value +
      " ถึง " +
      form.toDate +
      " เวลา " +
      document.getElementById("toTime").value;
    setSubTitle(SubTitle);
    Query = JSON.stringify(Query);

    var result = await axios.post(
      Conf.digitalpayBackend + "bill",
      {
        query: Query,
        limit: 1000,
      },
      { headers: { Authorization: cookie.token } }
    );
    result = result.data;
    var invoice_ids = [];
    for (let bill of result.bills) {
      invoice_ids.push(bill.invoice_id._id);
    }
    let invoices = await getInvoices(invoice_ids);
    result.sumation = {
      amount: 0,
      cash: 0,
      tranfer: 0,
      canceled: 0,
    };
    for (let bill of result.bills) {
      let invoice = invoices.find((j) => j._id === bill.invoice_id._id);
      let amount = invoice.amount;

      if (!bill.canceled || bill.canceled.status !== true) {
        result.sumation.amount += amount;
        if (bill.transactionType === "Pay by Cash")
          result.sumation.cash += amount;
        else result.sumation.tranfer += amount;
      }
      if (bill.canceled && bill.canceled.status === true)
        result.sumation.canceled++;
      bill.details = invoice.details;
    }
    console.log(result);
    setBills(result);
  }

  function getInvoices(ids) {
    return new Promise(async (resolve) => {
      let Invoices = await axios.post(
        Conf.digitalpayBackend + "invoice",
        {
          ids: ids,
          facet: true,
          limit: 1000,
        },
        { headers: { Authorization: cookie.token } }
      );
      resolve(Invoices.data.invoices);
    });
  }
  function printReport() {
    document.getElementById("printFrame").src = "";
    if (bills) {
      cookie.print = bills;
      cookie.print.subTitle = subTitle;
      localStorage.setItem(Conf.cookieName, JSON.stringify(cookie));
      document.getElementById("printFrame").src =
        process.env.PUBLIC_URL + "/print/delevery";
    }
  }
  return (
    <div>
      {profile && (
        <>
          <Navbar />
          <main className="content">
            <PageHead
              icon={<EventAvailableIcon style={{ fontSize: "2rem" }} />}
              title={page_title}
              profile={profile}
            />
            <FilterForm onChangeForm={(form) => changeFilter(form)} />
            <br />
            {bills && bills.sumation && (
              <>
                <Paper>
                  <br />
                  <PersonalReceptTable
                    bills={bills.bills}
                    sumation={bills.sumation}
                    subTitle={subTitle}
                  />
                  <br />
                </Paper>
                <br />
                <div style={{ textAlign: "center" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<PrintIcon />}
                    style={{ width: "250px" }}
                    onClick={printReport}
                  >
                    Print
                  </Button>
                </div>
              </>
            )}
          </main>
        </>
      )}
    </div>
  );
}

function FilterForm(props) {
  const [form, setForm] = useState(null);
  const [filter, setFilter] = useState(null);

  useEffect(() => {
    async function mountComponent() {
      var stampTime = await getStampTime();
      let Form = {
        fromDate: stampTime.iso_date,
        fromTime: "06:00",
        toDate: stampTime.iso_date,
        toTime: stampTime.slice_time.hour + ":" + stampTime.slice_time.minute,
      };

      // props.onChangeForm(Form);
      setForm(Form);
      setFilter(Form);
    }
    mountComponent();
  }, []);

  useEffect(() => {
    if (filter) {
      setFilter(null);
      props.onChangeForm(filter);
    }
  }, [props, filter]);

  const sendForm = async () => {
    let fromTime = await getStampTime(form.fromTime);
    let toTime = await getStampTime(form.toTime);
    var send = {
      fromDate: form.fromDate,
      fromTime: fromTime.host_time,
      toDate: form.toDate,
      toTime: toTime.host_time,
    };
    setFilter(send);
    // props.onChangeForm(send);
  };

  function changeDate(date, date2, id) {
    var Form = JSON.parse(JSON.stringify(form));
    Form[id] = date2;
    setForm(Form);
  }
  return (
    <>
      {form && (
        <div>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container spacing={1}>
              <Grid item xs={6} md={3}>
                <KeyboardDatePicker
                  margin="normal"
                  id="fromDate"
                  label="From Date"
                  format="yyyy-MM-dd"
                  value={form.fromDate}
                  onChange={(date, date2) =>
                    changeDate(date, date2, "fromDate")
                  }
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  autoOk
                  inputVariant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid item xs={6} md={3} style={{ paddingTop: "20px" }}>
                <TextField
                  label="Form Time"
                  id="fromTime"
                  type="time"
                  value={form.fromTime}
                  // value="06:00"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setForm({ ...form, fromTime: e.target.value })
                  }
                  fullWidth
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <KeyboardDatePicker
                  margin="normal"
                  label="To Date"
                  format="yyyy-MM-dd"
                  value={form.toDate}
                  autoOk
                  // onChange={(date, date2) => changeDate(date, date2, "toDate")}
                  onChange={(date, date2) => changeDate(date, date2, "toDate")}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  inputVariant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid item xs={6} md={3} style={{ paddingTop: "20px" }}>
                <TextField
                  label="Form Time"
                  id="toTime"
                  type="time"
                  value={form.toTime}
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setForm({ ...form, toTime: e.target.value })}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} align="right">
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<ReplayIcon />}
                  onClick={sendForm}
                >
                  Reload
                </Button>
              </Grid>
            </Grid>
          </MuiPickersUtilsProvider>
        </div>
      )}
    </>
  );
}
